"use strict";
/**
 * @packageDocumentation
 * @module Logger.Builders
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoggerNewLevelBuilder = exports.LoggerLevelBuilder = void 0;
var levels_1 = require("../constants/levels");
var LoggerLevel_1 = require("../models/logger/LoggerLevel");
var LoggerLevelBuilder = /** @class */ (function () {
    function LoggerLevelBuilder() {
    }
    LoggerLevelBuilder.get = function () {
        if (LoggerLevelBuilder.cached !== undefined) {
            return LoggerLevelBuilder.cached;
        }
        else {
            LoggerLevelBuilder.cached = new LoggerLevelBuilder();
            return LoggerLevelBuilder.cached;
        }
    };
    LoggerLevelBuilder.new = function () {
        return new LoggerNewLevelBuilder();
    };
    Object.defineProperty(LoggerLevelBuilder.prototype, "silent", {
        get: function () {
            return levels_1.silent;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LoggerLevelBuilder.prototype, "error", {
        get: function () {
            return levels_1.error;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LoggerLevelBuilder.prototype, "warn", {
        get: function () {
            return levels_1.warn;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LoggerLevelBuilder.prototype, "info", {
        get: function () {
            return levels_1.info;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LoggerLevelBuilder.prototype, "debug", {
        get: function () {
            return levels_1.debug;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LoggerLevelBuilder.prototype, "silly", {
        get: function () {
            return levels_1.silly;
        },
        enumerable: false,
        configurable: true
    });
    LoggerLevelBuilder.prototype.withName = function (str, def) {
        if (def === void 0) { def = levels_1.info; }
        return levels_1.toLevel(str, def);
    };
    return LoggerLevelBuilder;
}());
exports.LoggerLevelBuilder = LoggerLevelBuilder;
var LoggerNewLevelBuilder = /** @class */ (function () {
    function LoggerNewLevelBuilder() {
        this.level = -1;
        this.name = "";
        this.stream = process.stdout;
    }
    LoggerNewLevelBuilder.prototype.withLevel = function (lv) {
        this.level = lv;
        return this;
    };
    LoggerNewLevelBuilder.prototype.withName = function (name) {
        this.name = name;
        return this;
    };
    LoggerNewLevelBuilder.prototype.withStream = function (writer) {
        this.stream = writer;
        return this;
    };
    LoggerNewLevelBuilder.prototype.get = function () {
        return new LoggerLevel_1.LoggerLevel(this.level, this.name, this.stream);
    };
    return LoggerNewLevelBuilder;
}());
exports.LoggerNewLevelBuilder = LoggerNewLevelBuilder;
//# sourceMappingURL=LoggerLevelBuilder.js.map